export default {
  src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  autoBlockSrc:
    'https://cdn.cookielaw.org/consent/8b030b9c-d802-4a07-8032-cb8864add49a/OtAutoBlock.js',
  domainScript: '8b030b9c-d802-4a07-8032-cb8864add49a',
};
